export default "__VITE_ASSET__CrGrjPKh__"